import { TICKET_TYPE_STRING } from "@src/components/deungi/common/enum";
import { TicketPackageListResponseDto } from "@src/hooks/deungi/dto/PackageList.dto";
import { transferToNative } from "@src/lib/WebAppBridge";

export interface BasePaymentParams {
    product_code: string;
    productType: string;
    ticketType: number;
    searchText: string;
    domain: "missgorealty.com";
}

export interface AndroidPaymentParams extends BasePaymentParams {
    pgType: string;
    product_name: string;
    discounted_price: number;
    type: TICKET_TYPE_STRING;
    original_price?: number;
    domain: "missgorealty.com";
}

export interface IosPaymentParams {
    product_code: string;
    productType: TICKET_TYPE_STRING;
    ticketType: number;
    searchText: string;
    domain: "missgorealty.com";
}

// Create Commonness Payment Params
export const createBasePaymentParams = (item: TicketPackageListResponseDto): BasePaymentParams => ({
    product_code: item.code,
    productType: item.type,
    ticketType: item.type.indexOf(item.type),
    searchText: "",
    domain: "missgorealty.com",
});

// Create Android Payment Params
export const createAndroidPaymentParams = (
    item: TicketPackageListResponseDto,
    paymentType: TICKET_TYPE_STRING = TICKET_TYPE_STRING.DEUNGI_TICKET,
): AndroidPaymentParams => {
    const baseParams = createBasePaymentParams(item);

    let productName = item.name;
    if (paymentType === TICKET_TYPE_STRING.OWNER_CHECK_TICKET) {
        productName = item.discountString || item.name;
    }

    const androidParams: AndroidPaymentParams = {
        ...baseParams,
        pgType: "kcp.IP29N",
        product_name: productName,
        discounted_price: item.discountPrice,
        type: paymentType,
    };

    if (paymentType === TICKET_TYPE_STRING.OWNER_CHECK_TICKET && item.originalPrice) {
        androidParams.original_price = item.originalPrice;
    }

    return androidParams;
};

export const createIosPaymentParams = (
    item: TicketPackageListResponseDto,
    paymentType: TICKET_TYPE_STRING = TICKET_TYPE_STRING.DEUNGI_TICKET,
): IosPaymentParams => {
    const iosParams: IosPaymentParams = {
        product_code: item.code,
        productType: paymentType,
        ticketType: item.type.indexOf(item.type),
        searchText: "",
        domain: "missgorealty.com",
    };

    return iosParams;
};

// Create Platform Payment Handler
export const handlePlatformPayment = (
    deviceDivision: string,
    item: TicketPackageListResponseDto,
    paymentType: TICKET_TYPE_STRING,
) => {
    localStorage.setItem("selectedProduct", JSON.stringify(item));
    switch (deviceDivision) {
        case "ios": {
            const iosParams = createIosPaymentParams(item, paymentType);
            transferToNative(JSON.stringify(iosParams), "payTicketInApp");
            break;
        }
        case "android": {
            const androidParams = createAndroidPaymentParams(item, paymentType);
            transferToNative(JSON.stringify(androidParams), "payDeungiTicketInApp");
            break;
        }
        default:
            break;
    }
};
